/** Estimated coverage from current stock and the last twelve completed months of net issues. */
export function getDaysOfSupply(
  annualPartUsage: number | null,
  currentInventoryQuantity: number | undefined
): number | null {
  if (
    annualPartUsage === null ||
    annualPartUsage <= 0 ||
    currentInventoryQuantity === undefined ||
    currentInventoryQuantity < 0
  ) {
    return null;
  }
  return (365 * currentInventoryQuantity) / annualPartUsage;
}
